import request from '../config/axiosConfig';
import { GET_LIST_CONFIGS, GET_CONFIG_INFO, CREATE_CONFIG, UPDATE_CONFIG, DELETE_CONFIG } from '../constants/configApiEndPoint';

export const getConfigs = async (params) => {
  return (
    await request({
      url: GET_LIST_CONFIGS,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getConfigInfo = async (id) => {
  return (
    await request({
      url: GET_CONFIG_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createConfig = async (data) => {
  return (
    await request({
      url: CREATE_CONFIG,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateConfig = async (id, data) => {
  return (
    await request({
      url: UPDATE_CONFIG,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteConfig = async (id) => {
  return (
    await request({
      url: DELETE_CONFIG,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
